export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    arrow: p => p.accentWhite,
    background: p => `${p.tertiaryDark}`,
    lightBackground: p => p.tertiaryExtraLight,
    socialBackground: p => p.accentWhite,
    socialColor: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    arrow: p => p.tertiaryDark,
    background: p => `${p.tertiaryLight}`,
    socialBackground: p => p.tertiaryDark,
    socialColor: p => p.accentWhite,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    navbarBg: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    arrow: p => p.tertiaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    background: p => `${p.tertiaryExtraLight}`,
    socialBackground: p => p.tertiaryDark,
    socialColor: p => p.accentWhite,
    backgroundColor: p => p.tertiaryExtraLight,
    navbarBg: p => p.tertiaryExtraLight
  }
}
